import { GenerateUsernameSuggestionResp } from 'types/api/response/generate-username-suggestion-resp'

import { api } from './api'

export const getUsernameSuggestion = (fullname: string) =>
  api.post<GenerateUsernameSuggestionResp>('/users/generate_username', {
    fullname,
  })
